export default "__VITE_ASSET__CxHYPCzz__"